// extracted by mini-css-extract-plugin
export default {"root":"IconSearchStrong_root__nBX8r"};